import { render } from "./BoardCard.vue?vue&type=template&id=20b83e70"
import script from "./BoardCard.vue?vue&type=script&lang=js"
export * from "./BoardCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__